import { render, staticRenderFns } from "./CV Pereira.vue?vue&type=template&id=7ac88568&"
import script from "./CV Pereira.vue?vue&type=script&lang=js&"
export * from "./CV Pereira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports